import React from 'react';
import { SectionHeading } from './ui/SectionHeading';
import { FadeIn } from './ui/FadeIn';
export function Testimonios() {
  const testimonios = [{
    texto: '"Me llegó un presupuesto altísimo y con el Tomo 2 entendí exactamente qué me cobraban de más. Ahorré como 40 lucas en un service. No puedo creer que no existía esto antes."',
    avatar: '🧔',
    nombre: 'Diego, 39 años',
    meta: 'Quilmes, Buenos Aires'
  }, {
    texto: '"Uso la moto para laburar todos los días. Con Service Pro aprendí a hacer el service de los 10k en casa. Lo que antes pagaba en el taller ahora lo hago yo. Una diferencia enorme para el bolsillo."',
    avatar: '👨‍🔧',
    nombre: 'Mateo, 27 años',
    meta: 'Córdoba Capital'
  }, {
    texto: '"Tengo un Gol del 2009 y siempre me daban presupuestos distintos en cada taller. Con el Checklist de Recepción ya sé qué pedir antes de que me digan nada. Me da mucha más tranquilidad cada vez que llevo el auto."',
    avatar: '👨‍💼',
    nombre: 'Pablo, 44 años',
    meta: 'Rosario, Santa Fe'
  }];
  return <section className="bg-mc-dark py-[72px] px-5" data-id="element-173">
      <div className="max-w-[1100px] mx-auto text-center" data-id="element-174">
        <FadeIn data-id="element-175">
          <SectionHeading centered data-id="element-176">
            Lo que dicen los que ya{' '}
            <span className="text-mc-yellow" data-id="element-177">blindaron su bolsillo</span>
          </SectionHeading>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10 text-left" data-id="element-178">
          {testimonios.map((testi, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-179">
              <div className="bg-mc-gray rounded-xl py-7 px-6 border-t-4 border-mc-yellow flex flex-col gap-3 h-full" data-id="element-180">
                <div className="text-mc-yellow text-[1.1rem] tracking-widest" data-id="element-181">
                  ★★★★★
                </div>
                <div className="text-[0.95rem] text-gray-200 leading-[1.7] flex-1 italic" data-id="element-182">
                  {testi.texto}
                </div>
                <div className="text-[0.85rem] font-bold text-mc-yellow flex items-center gap-2.5 mt-2" data-id="element-183">
                  <div className="w-10 h-10 bg-mc-gray2 rounded-full flex items-center justify-center text-[1.3rem] shrink-0" data-id="element-184">
                    {testi.avatar}
                  </div>
                  <div data-id="element-185">
                    <strong data-id="element-186">{testi.nombre}</strong>
                    <div className="text-[0.75rem] text-mc-text font-normal" data-id="element-187">
                      {testi.meta}
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}